import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { burstConfetti } from "@/lib/confetti";
import { DynIcon, RARITY } from "@/components/shared";
import { Button } from "@/components/ui/button";

export default function Celebration({ open, onClose, data }) {
  useEffect(() => {
    if (open) burstConfetti();
  }, [open]);

  if (!data) return null;
  const rarity = RARITY[data.rarity || "epic"] || RARITY.epic;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="celebration-modal"
          className="fixed inset-0 z-[100] flex items-center justify-center p-6"
          style={{ backgroundColor: "rgba(0,41,87,0.85)" }}
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        >
          <motion.div
            initial={{ scale: 0.6, y: 40 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.7, opacity: 0 }}
            transition={{ type: "spring", stiffness: 260, damping: 18 }}
            className="w-full max-w-md rounded-[2rem] bg-white p-8 text-center shadow-2xl"
          >
            <p className="font-head text-2xl text-csh-orange tracking-wide">{data.heading || "CONGRATULATIONS!"}</p>
            <p className="mt-1 text-sm font-bold uppercase tracking-widest text-muted-foreground">{data.subheading || "You Unlocked"}</p>
            <motion.div
              className="mx-auto my-6 flex h-32 w-32 items-center justify-center rounded-full"
              style={{ backgroundColor: (data.color || rarity.ring) + "22", border: `4px solid ${data.color || rarity.ring}` }}
              animate={{ rotate: [0, -8, 8, 0], scale: [1, 1.08, 1] }}
              transition={{ duration: 1.2, repeat: Infinity, repeatDelay: 0.5 }}
            >
              <DynIcon name={data.icon || "Award"} size={56} color={data.color || rarity.ring} />
            </motion.div>
            <h2 className="font-head text-3xl text-csh-blue">{data.title}</h2>
            {data.message && <p className="mt-2 text-base text-muted-foreground">"{data.message}"</p>}
            {data.points ? (
              <div className="mt-4 inline-block rounded-full gradient-orange px-5 py-2 font-head text-xl text-white">
                +{data.points} XP
              </div>
            ) : null}
            <Button
              data-testid="celebration-close-btn"
              onClick={onClose}
              className="mt-6 w-full rounded-full gradient-purple py-6 font-head text-lg uppercase tracking-wide text-white hover:scale-[1.02] active:scale-95"
            >
              {data.cta || "Awesome!"}
            </Button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
